import 'bootstrap-validator';
import HeaderNav from 'components/header-nav';
import { apiUrl } from 'config/constants';
import loaderHtml from 'components/loader';
import { redirect } from 'utils/helpers';

'use strict';

const InterviewView = {
    /**
     * Initialize the view
     */
    init() {

        $.material.init();

        this.$body = $('body');
        this.$body.append(`<div class="loader-overlay">${loaderHtml}</div>`);
        this.$body.removeClass('hidden');
        this.$userForm = $('#interview-user-form');
        this.$userTools = $('#interview-tools-form');
        this.$cityForm = $('#interview-city-form');
        this.$descriptionForm = $('#interview-description-form');
        this.interviewData = {};


        // setup the form validation
        $('form.interview__form').validator({
            disable: false,
            feedback: {
                success: 'fa-check',
                error: 'fa-remove'
            }
        });

        HeaderNav.init({}).then((success) => {
            if (success) {
                this.user = HeaderNav.me();
                this.userPermissions = HeaderNav.permissions();
                this.userCity = HeaderNav.getCity();
            }
            else {
                redirect('/');
            }
        });


        $('#role').customSelect('init');

        this.bindEvents();
    },

    /**
     * Method to show/hide the sections
     * @param {string} sectionId - the id selector of the section to show
     * @param {Boolean} noAnimation - if true then no transition animation will be applied
     */
    showInterviewSection(sectionId, noAnimation = false) {

        const $sections = $('section.interview-section'),
            $sectionToHide = $sections.filter('.is-active'),
            $sectionToShow = $(sectionId);

        $sectionToHide.removeClass('is-active');
        $sectionToShow.addClass('is-active');

        if (!noAnimation) {
            $sectionToShow.addClass('is-animating');
            $sectionToHide.addClass('is-animating is-exiting');
        }

        $sectionToShow.on('transitionend webkitTransitionEnd', this.handleSectionTransitionEnd.bind(this, $sectionToShow, $sectionToHide));
    },


    /**
     * Remove classes from the sections after the transition animation completes
     * @param {Object} $sectionToShow - the jQuery selector for the section that becomes visible
     * @param {Object} $sectionToHide - the jQuery selector for the section that becomes hidden
     */
    handleSectionTransitionEnd($sectionToShow, $sectionToHide) {
        $sectionToHide.removeClass('is-animating is-exiting');
        $sectionToShow.removeClass('is-animating').off('transitionend webkitTransitionEnd');
    },


    /**
     * Show the appropriate section after clicking a link
     * @param {Object} e - "submit" event object
     */
    handleSectionLinkClick(e) {
        e.preventDefault();

        this.showInterviewSection(e.currentTarget.hash);
    },



    /**
     * Handle submission for the user form
     * @param {Object} e - "submit" event object
     */
    handleUserInfo(e) {
        if (!e.isDefaultPrevented()) {
            e.preventDefault();

            const nextSectionHash = $(e.target).find('.js-section-link').data('nextSection'),
                first = $('#first-name').val();
            let userData = {};
            $('.js-first').text(first);

            this.$userForm.serializeArray().forEach((item) => {
                if (userData[item.name]) {
                    userData[item.name] += ` - ${item.value}`;
                }
                else {
                    userData[item.name] = item.value;
                }
            });

            this.interviewData = $.extend(this.interviewData, userData);
            this.showInterviewSection(nextSectionHash);
        }
    },


    /**
     * Handle submission for the tools form
     * @param {Object} e - "submit" event object
     */
    handleUserTools(e) {
        if (!e.isDefaultPrevented()) {
            e.preventDefault();

            let userTools = {};

            this.$userTools.serializeArray().forEach((item) => {
                if (userTools[item.name]) {
                    userTools[item.name] += ` - ${item.value}`;
                }
                else {
                    userTools[item.name] = item.value;
                }
            });
            this.interviewData = $.extend(this.interviewData, userTools);
        }
    },


    /**
     * Handle submission for the user details form
     * @param {Object} e - "submit" event object
     */
    handleUserDetails(e) {
        if (!e.isDefaultPrevented()) {
            e.preventDefault();

            const nextSectionHash = $(e.target).find('.js-section-link').data('nextSection');
            let cityForm = {};

            this.$cityForm.serializeArray().forEach((item) => {
                if (cityForm[item.name]) {
                    cityForm[item.name] += ` - ${item.value}`;
                }
                else {
                    cityForm[item.name] = item.value;
                }
            });

            this.interviewData = $.extend(this.interviewData, cityForm);


            this.showInterviewSection(nextSectionHash);
        }
    },


    /**
     * Handle submission for the user description form
     * @param {Object} e - "submit" event object
     */
    handleUserDescription(e) {
        if (!e.isDefaultPrevented()) {
            e.preventDefault();

            const nextSectionHash = $(e.target).find('.js-section-link').data('nextSection');
            let descriptionForm = {};

            this.$descriptionForm.serializeArray().forEach((item) => {
                if (descriptionForm[item.name]) {
                    descriptionForm[item.name] += ` - ${item.value}`;
                }
                else {
                    descriptionForm[item.name] = item.value;
                }
            });
            this.interviewData = $.extend(this.interviewData, descriptionForm);


            // after successful form validation proceed with submission
            this.submitUserData(this.interviewData, nextSectionHash);
        }
    },

    /**
     * Submit the user entered data to the api
     * @param {Object} contactData - the user entered data
     */
    submitUserData(userData, nextPanel) {
        this.$body.addClass('is-loading');
        window.Api.Survey.createOne(userData).then((res) => {
            this.$body.removeClass('is-loading');
            if (res.isOk) {
                this.showInterviewSection(nextPanel);
            }
            else {
                $.snackbar({ content: 'We couldn\'t save your interview at the moment. Please try again later.' });
            }
        }, () => {
            this.$body.removeClass('is-loading');
            $.snackbar({ content: 'We couldn\'t save your interview at the moment. Please try again later.' });
        });
    },

    /**
     * Handle change event of file input
     * @param e {Event} change event object
     */
    handleUpload(e) {
        let $field = $(e.target);

        this.$body.addClass('is-loading');
        this.uploadRequest(e.target.files[0], $field);
    },


    /**
     * Async upload request
     * @param file {File}
     * @param $field {jQuery} file input node
     */
    uploadRequest(file, $field) {
        let formData = new FormData();

        formData.append('file', file);
        $.ajax({
            url: apiUrl + 'files/upload',
            cache: false,
            contentType: false,
            processData: false,
            data: formData,
            type: 'post',
            xhrFields: {
                withCredentials: true
            },
            success: (res) => {
                this.$body.removeClass('is-loading');
                this.$cityForm.find('.js-resume').val(res);
            },
            error: () => {
                this.$body.removeClass('is-loading');
                this.$cityForm.find('.js-resume').val('');
            }
        });
    },


    /**
     * Bind the various UI events
     */
    bindEvents() {

        // show the appropriate booking section
        $(document).on('click', 'a.js-section-link', this.handleSectionLinkClick.bind(this));

        this.$userForm.on('submit', this.handleUserInfo.bind(this));

        this.$userTools.on('click', '#tools-submit', this.handleUserTools.bind(this));

        this.$cityForm.on('submit', this.handleUserDetails.bind(this));

        this.$cityForm.on('change', 'input[type=\'file\']', this.handleUpload.bind(this));

        this.$descriptionForm.on('submit', this.handleUserDescription.bind(this));
    },
};

/* start-test */
/* istanbul ignore if  */
if (!window.__karma__) {
    /* end-test */
    InterviewView.init();
    /* start-test */
}

/* end-test */
export default InterviewView;
